import styled from 'styled-components';
import {BGImageCenter, dFlexCenter, dFlexSpaceBetween, GRAY, mobileMedia, searchResult} from '../../../../globalVariables/GlobalVariables';
import {editPencil} from '../../../../assets/symbols/symbols/Symbols.css';
import {Popup} from '../bottomPopup/BottomPopup.css';

export const item=styled.div`
       ${dFlexSpaceBetween};
        height: 60px;
        width: 220px;
        padding: 10px;
        position: relative;
        margin:1px 0 ;
        ${mobileMedia}{
         width: 100%;
         /* padding-right: 20px;
         padding-left: 20px; */
        }
        ${searchResult()  }
        ${(p) => (p.disabled && p.disabled==true ? 'opacity: .4; pointer-events: none; cursor: default; ': '')};
      ${Popup}{
              position: fixed;
              width: 790px;
              max-width: 95%;
      }
    `;

export const right=styled.div`
        display: block;
        font-size: 10px;
`;
export const name=styled.div`
        font-size: 14px;
        font-weight: 500;

`;

export const actionsContainer = styled.div`
        ${dFlexCenter};
`;

export const editIcon = styled.div`
        width: 23px;
        height: 23px;
        border-radius: 50%;
        background-color: ${GRAY};
        cursor: pointer;
        ${BGImageCenter(editPencil, '12px')}
        transition: background-color 0.2s ease;
        border: 1px solid ${GRAY};
        margin-inline-end: 8px;
`;
